<div class="logout-menu">
    <ct-user-avatar></ct-user-avatar>
    <div class="logout-menu__info">
        <div class="logout-menu__info-username ellipsis">{{userName}}</div>
        <div class="logout-menu__info-mail ellipsis">{{email}}</div>
    </div>
    <div class="logout-menu__logout_button" (click)="logout.emit()">{{TEXT.header.logOff}}</div>
</div>
